import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHandler, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable, observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as cors from 'corslite';

@Injectable()
export class MapDataService {

  private  baseUrl = environment.baseUrl;
  constructor(private http:HttpClient) { }

  getIpAddress() {
    return this.http
          .get('https://api.ipify.org/?format=json')
          .pipe(
            catchError(this.handleError)
          );
  } 

  getGEOLocation(ip) {
    // Update your api key to get from https://ipgeolocation.io
    let url = "https://api.ipgeolocation.io/ipgeo?apiKey=YourAPIKEY&ip="+ip; 
      return this.http
            .get(url)
            .pipe(
              catchError(this.handleError)
            );
    } 
     
  getInitialMapCoordinates(){
    return new Observable((subscriber) => {
      cors(`https://ipapi.co/json/`, (err: XMLHttpRequest, resp: XMLHttpRequest) => {
          if(resp) {
            subscriber.next(JSON.parse(resp.responseText));
          }else {
            subscriber.error(JSON.parse(err.responseText));
          }
      })
    })
  }


  getComputedCoordinates(data:any){
    return this.http.post(`${this.baseUrl}/api/Converter/ComputeCoordinates`,data)
          .pipe(
            catchError(this.handleError)
          );
  }

  getMapSearchData(searchStr:string){
    return this.http.get(`${this.baseUrl}/api/Converter/Search?Place=${searchStr}`)
              .pipe(
                catchError(this.handleError)
              );
  }

 reverseGeocodeCoordinates(lat:number,long:number){
    let headers = new HttpHeaders();
    headers = headers.append('X-Skip-Loader', 'true') 
      return this.http.get(`${this.baseUrl}/api/Map/GetRoadPoint?Latitude=${lat}&Longitude=${long}`,
      {headers})
      .pipe(
        catchError(this.handleError)
      );
  }

  reverseGeocodeCoordinatesForPlaceWaypointOnRoad(lat:number,long:number){
    let headers = new HttpHeaders();
    headers = headers.append('X-Skip-Loader', 'true') 
      return this.http.get(`${this.baseUrl}/api/Map/PlaceNearestRoad?Latitude=${lat}&Longitude=${long}`,
      {headers})
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error:HttpErrorResponse) {
    if(error.error instanceof ErrorEvent) {
      console.error('An error occured', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error}`
      );
    }
    return throwError(error.error);
  }
}
